import { render, staticRenderFns } from "./PaymentSystem.vue?vue&type=template&id=06d95207&scoped=true"
import script from "./PaymentSystem.vue?vue&type=script&lang=js"
export * from "./PaymentSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d95207",
  null
  
)

export default component.exports